import { render, staticRenderFns } from "./TeacherLayout.vue?vue&type=template&id=54b5fb87&scoped=true"
import script from "./TeacherLayout.vue?vue&type=script&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&lang=js"
import style0 from "./TeacherLayout.vue?vue&type=style&index=0&id=54b5fb87&prod&lang=css"
import style1 from "./TeacherLayout.vue?vue&type=style&index=1&id=54b5fb87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5fb87",
  null
  
)

export default component.exports